import {GET} from "@/services/gateway";

const getBackupsByDay = () => {
  return GET('dashboard/box/backups')
}

export {
  getBackupsByDay,
}
